export const classes = {
  card: 'rounded-xl overflow-hidden bg-white dark:bg-[#332e43] shadow-card px-6 py-4',
};
